export const getDefaultPackaging = (packaging, defaultPackagingId) => {
  return packaging?.find(p => p.id === defaultPackagingId)
}
